import { RangeDateInput, TextInput } from '@core/components/Inputs';
import SelectInput from '@core/components/Select/SelectInput';
import { FormControl, Grid } from '@material-ui/core';
import { SelectServico } from 'app/components/Select';
import SelectProduto from 'app/components/Select/SelectProduto';
import { ALPHA_NUMERIC_REGEX } from 'app/utils/patternUtil';
import { useFormikContext } from 'formik';
import React from 'react';

const NotaFiscalBuscaAvancadaForm = () => {
  const formik = useFormikContext();

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <RangeDateInput
          id="periodoEmissao"
          name="periodoEmissao"
          value={[formik.values.periodoEmissaoInicio, formik.values.periodoEmissaoFim]}
          label="Período de emissão"
          onBlur={formik.handleBlur}
          onChange={(inicio, fim) => {
            formik.setFieldValue('periodoEmissaoFim', fim);
            formik.setFieldValue('periodoEmissaoInicio', inicio);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControl variant="outlined" style={{ width: '100%' }}>
          <SelectInput
            id="tipo"
            name="tipo"
            label="Tipo"
            value={formik.values?.tipo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            options={[
              { id: 'VENDA', title: 'Venda' },
              { id: 'CONTRATO', title: 'Contrato' },
              { id: 'VENDA_CONTRATO', title: 'Venda e contrato' },
              { id: 'VENDA_A_ORDEM', title: 'Venda à ordem' },
              { id: 'VENDA_ENTREGA_FUTURA', title: 'Venda de entrega futura' },
              { id: 'NOTA_REMESSA', title: 'Nota de remessa' },
              { id: 'NOTA_DEVOLUCAO', title: 'Nota de devolução' },
            ]}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectServico
          id="servico"
          name="servico"
          label="Serviço"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.servico}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectProduto
          id="produto"
          name="produto"
          label="Produto"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.produto}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectInput
          id="situacao"
          label="Situação"
          onChange={formik.handleChange}
          value={formik.values?.situacao}
          options={[
            { id: 'EM_FATURAMENTO', title: 'Em faturamento' },
            { id: 'FATURADO', title: 'Faturado' },
            { id: 'ERRO_TRANSMISSAO', title: 'Erro de transmissão' },
            { id: 'CANCELADO', title: 'Cancelado' },
            { id: 'EM_CANCELAMENTO', title: 'Em cancelamento' },
            { id: 'ERRO_CANCELAMENTO', title: 'Erro de cancelamento' },
            { id: 'EM_EMISSAO', title: 'Em emissão' },
            { id: 'EMITIDA', title: 'Emitida' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="serieNF"
          nome="serieNF"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.serieNF}
          fullWidth
          variant="outlined"
          label="Série / NF"
          pattern={ALPHA_NUMERIC_REGEX}
          maxLength={100}
        />
      </Grid>
    </Grid>
  );
};

export default NotaFiscalBuscaAvancadaForm;
